import { useEffect } from 'react'
import { DEFAULT_MAP_CENTER, DEFAULT_MAP_ZOOM, getMap, useGoogleLoadState } from '../stores/GoogleMapState'

export const useReturnMapToDefaultView = () => {

  const mapLoaded = useGoogleLoadState()
  const map = getMap()
  useEffect(() => {
    if (mapLoaded.value && map) {
      map.setCenter(DEFAULT_MAP_CENTER)
      map.setZoom(DEFAULT_MAP_ZOOM)
      map.setOptions({
        minZoom: DEFAULT_MAP_ZOOM
      })
      map.fitBounds({
        east: 178.644431,
        north: -34.094485,
        south: -47.317516,
        west: 166.129201,
      })
    }
  }, [mapLoaded.value, map])
}
